import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	singleCreateWorkItemName: {
		id: 'jira-work-create-extension.single-create-work-item.name',
		defaultMessage: 'Create Jira work item',
		description: 'Name for the single create work item button',
	},
	// [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
	// New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
	singleCreateWorkItemNameUpdated: {
		id: 'jira-work-create-extension.single-create-work-item.name.updated',
		defaultMessage: 'Jira work item',
		description: 'Name for the single create work item button',
	},
	bulkCreateWorkItemName: {
		id: 'jira-work-create-extension.bulk-create-work-item.name',
		defaultMessage: 'Create Jira work items',
		description: 'Name for the bulk create work item button',
	},
	// [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
	// New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
	bulkCreateWorkItemNameUpdated: {
		id: 'jira-work-create-extension.bulk-create-work-item.name.updated',
		defaultMessage: 'Jira work items',
		description: 'Name for the bulk create work item button',
	},
});
